




























































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { mdiTrashCanOutline, mdiGreasePencil } from '@mdi/js';
import BaseModalView from '@/components/base/BaseModalView.vue';
import AccountDetailsForm from '@/components/profile/personal-details/account/AccountDetailsForm.vue';
// eslint-disable-next-line no-unused-vars
import { AccountDetailsTableData } from '@/types/accountDetails';
import ConfirmationModalView from '@/components/base/ConfirmationModalView.vue';
import {
  deleteBankDetails,
  getBankDetails,
  saveBankDetails,
} from '@/api/profile';
import cloneDeep from 'clone-deep';
import PreLoader from '@/components/base/PreLoader.vue';
import { errorHandler, isNotEmptyObjectCheck } from '@/utils/common';

@Component({
  components: {
    PreLoader,
    ConfirmationModalView,
    AccountDetailsForm,
    BaseModalView,
  },
  data: () => ({
    mdiTrashCanOutline,
    mdiGreasePencil,
    isNotEmptyObjectCheck,
  }),
})
export default class AccountDetailsTable extends Vue {
  @Prop({ default: false }) fullViewMode: boolean;
  @Prop() editable: boolean;
  @Prop() removable: boolean;
  @Prop() selectable: boolean;
  @Prop() addButtonShow: boolean;
  @Prop({ default: 'Нет реквизитов' }) emptyText: string;
  @Prop({ default: 'Добавить реквизиты счета' }) addButtonText: string;

  private readonly columns = [3, 3, 3, 3];
  private loading = false;
  private selectedItemIndex = '0';
  private accountDetailsModalViewShow = false;
  private deleteConfirmationModalViewShow = false;

  private confirmationDelete = false;
  private editMode = false;
  private accountDataEdit: any = {};
  private data: AccountDetailsTableData[] = [];

  $refs!: {
    vue: Vue;
    accountDetailsModalForm: any;
  };

  //@Ref() readonly accountDetailsModalForm!: HTMLElement;

  mounted() {
    this.selectedItemIndex = '0';
  }

  created() {
    this.getData();
  }

  public async getData() {
    this.loading = true;
    this.data = await getBankDetails();
    this.loading = false;
  }

  get getFormTitle() {
    return this.editMode
      ? 'Редактирование реквизитов счета'
      : 'Добавление реквизитов счета';
  }

  get getButtonText() {
    return this.editMode ? 'Сохранить' : 'Добавить';
  }

  @Emit()
  selectDataRow(index: number) {
    return this.data[index];
  }

  clearDataByModalForm() {
    this.accountDetailsModalViewShow = false;
    this.$refs.accountDetailsModalForm.reset();
    this.selectedItemIndex = '0';
    this.accountDataEdit = {};
  }

  async deleteAccountData(id: string) {
    this.deleteConfirmationModalViewShow = true;
    await this.remove(id);
    this.confirmationDeleteAction(false);
  }

  confirmationDeleteAction(val: boolean) {
    this.deleteConfirmationModalViewShow = false;
    this.confirmationDelete = val;
  }

  async addAccountData() {
    try {
      const data = await this.$refs.accountDetailsModalForm.upload();
      if (data) {
        this.loading = true;
        await saveBankDetails(data);
        this.$emit('change', [...cloneDeep(this.data), data]);
        this.loading = false;
        this.clearDataByModalForm();
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      await this.getData();
      this.editMode = false;
    }
  }

  async edit(id: string) {
    this.editMode = true;
    this.accountDetailsModalViewShow = true;
    this.accountDataEdit = {
      ...this.data.filter((item: AccountDetailsTableData) => item.id === id)[0],
      id: id,
    };
  }

  async remove(id: string) {
    this.loading = true;
    await deleteBankDetails(id);
    await this.getData();
    this.loading = false;
  }

  upload() {
    const data = this.data[+this.selectedItemIndex];
    this.selectedItemIndex = '0';
    return data;
  }
}
